import paramService from './paramService';

export default paramService;